"use client";
import React from "react";

export default function ExperiencesSkeleton() {
  return (
    <section className="py-5 bg-light">
      <div className="container">

        {/* Heading */}
        <div className="text-center mb-4">
          <div className="exp-skeleton exp-skel-title mx-auto mb-2"></div>
          <div className="exp-skeleton exp-skel-line mx-auto"></div>
        </div>

        {/* Filters */}
        <div className="d-flex justify-content-center flex-wrap gap-2 mb-4">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="exp-skeleton exp-skel-pill"></div>
          ))}
        </div>

        {/* Cards */}
        <div className="row g-4">
          {[...Array(3)].map((_, i) => (
            <div
              key={i}
              className={`col-12 col-md-6 col-lg-4 ${
                i > 0 ? "d-none d-md-block" : ""
              }`}
            >
              <div className="card border-0 shadow-sm">

                {/* Image */}
                <div className="exp-skeleton exp-skel-img"></div>

                <div className="card-body px-2">
                  <div className="exp-skeleton exp-skel-text mb-3"></div>

                  <div className="d-flex gap-2 mb-3">
                    <div className="exp-skeleton exp-skel-btn-sm"></div>
                    <div className="exp-skeleton exp-skel-btn-sm"></div>
                  </div>

                  <div className="d-flex justify-content-between align-items-center">
                    <div className="exp-skeleton exp-skel-small"></div>
                    <div className="exp-skeleton exp-skel-price"></div>
                  </div>
                </div>

              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}